var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsenta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4140_7299)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4140_7299",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 98
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 0H0V98H98V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4140_7299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5207 14.2986V47.7488C60.5207 47.7488 61.4254 64.2986 45.6565 64.2986C29.8877 64.2986 30.534 47.7488 30.534 47.7488",
    stroke: "#604B2B",
    strokeWidth: 6.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6248 50.796C85.6248 50.796 85.6248 44.2236 77.5481 44.2236C69.4715 44.2236 67.9389 53.5548 67.9389 54.4473C67.9389 58.4232 71.1703 63.1293 77.5481 63.1293C83.9259 63.1293 88.9365 66.5372 88.9365 72.2982C88.9365 75.5438 87.568 81.2236 77.5481 81.2236C67.5282 81.2236 67.9389 74.0021 67.9389 74.0021",
    stroke: "#C8B18D",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9414 43.3895C78.3977 43.2236 76.611 43.2236 76.611 43.2236C66.4581 43.2236 66.9451 51.931 66.9451 53.6724C66.9451 55.4139 67.6726 58.3163 70.9227 60.2236",
    stroke: "#C8B18D",
    strokeWidth: 6.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9761 70.573C66.0969 70.573 79.9761 56.47 79.9761 39.073C79.9761 21.676 66.0969 7.573 48.9761 7.573C31.8552 7.573 17.9761 21.676 17.9761 39.073C17.9761 56.47 31.8552 70.573 48.9761 70.573Z",
    stroke: "#545454",
    strokeWidth: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2664 63.1788L31.8788 65.2398L12.372 94.9046L5.104 88.6874L29.2664 63.1788Z",
    fill: "#545454"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4140_7299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsenta);
export default __webpack_public_path__ + "static/media/jobsenta.1167ea73df41999eadee4ecd832cced7.svg";
export { ForwardRef as ReactComponent };